import { MainContainer } from "@/interface/components/layout/main-container";

export function NotFoundPage() {
  return (
    <MainContainer>
      <main className="flex h-screen flex-col items-center justify-center">
        <div className="relative mx-auto w-full max-w-md space-y-8 text-center">
          <div className="mb-8">
            <h2 className="mt-6 text-6xl font-extrabold text-nt-neutral-950 dark:text-gray-100">
              404
            </h2>
            <p className="mt-2 text-3xl font-bold text-nt-neutral-950 dark:text-gray-100">
              Pagina no encontrada
            </p>
            <p className="mt-2 text-sm text-nt-neutral-600 dark:text-gray-400">
              Lo sentimos, no pudimos encontrar la página que buscas.
            </p>
          </div>
          <div className="mt-8">
            <a
              href="/"
              className="inline-flex items-center rounded-md border border-transparent bg-nt-secondary px-4 py-2 text-base font-medium text-white transition-colors duration-200 ease-in-out hover:bg-nt-secondary-600 focus:outline-none focus:ring-2">
              <svg
                className="-ml-1 mr-2 h-5 w-5"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor">
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M3 12h18m-9-9l9 9-9 9"
                />
              </svg>
              Regresar al inicio
            </a>
          </div>
        </div>
      </main>
    </MainContainer>
  );
}
